import { jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { EventService } from "@perxis-auto/shared/lib";
import { Icon } from "@perxis-auto/ui-kit";
import "../../../entities/vehicle/api/api.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../entities/vehicle/model/selectors/selectVehicleParameters.js";
import "react-redux";
import "../../../features/benefitChoice/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "@perxis-auto/shared";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import { selectSort } from "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../../features/filterValues/api/api.js";
import "../../../features/filterValues/model/middleware/index.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import { APP_EVENTS } from "../../../shared/config/events.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/installation/middleware/index.js";
import "../../../entities/vehicle/model/selectors/selectIsVehiclesDataMissing.js";
import "../../../entities/vehicle/model/selectors/selectVehicle.js";
import "../../../entities/vehicle/model/selectors/selectVehicles.js";
import { selectVehiclesCount } from "../../../entities/vehicle/model/selectors/selectVehiclesCount.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesParameters.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesTotalPages.js";
import "react-router";
import "../../../shared/store/pagination/model/slice.js";
import "../../../features/filterChoice/model/middleware/index.js";
import "../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import { selectFilterSortValue } from "../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import "../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import "../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import { actions } from "../../../features/filterChoice/model/slice.js";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "../../../shared/lib/logger/index.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const props = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const dispatch = useAppDispatch();
  const eventService = EventService.getInstance();
  const sortValue = useAppSelector(selectFilterSortValue);
  const vehiclesCount = useAppSelector(selectVehiclesCount);
  const { items: sortItems, enable: isSortEnabled } = useAppSelector(selectSort);
  const resolvedSortItems = useMemo(
    () => sortItems.map((item2) => {
      return {
        key: JSON.stringify(item2.key),
        label: t(item2.label),
        icon: /* @__PURE__ */ jsx(Icon, { name: item2.icon })
      };
    }),
    [sortItems, t]
  );
  const onSortChange = useCallback(
    (key) => {
      const selectedSort = JSON.parse(key);
      eventService.sendEvent(APP_EVENTS.SortValueChanged, {
        previous: sortValue,
        selected: selectedSort
      });
      dispatch(actions.setSort(selectedSort));
    },
    [dispatch, eventService, sortValue]
  );
  return {
    ...props,
    vehiclesCount,
    items: resolvedSortItems,
    sortValue,
    isSortEnabled,
    onSortChange,
    t
  };
};
export {
  useContainer
};
